import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { BackdropLoadingComponent } from './features/backdrop-loading/backdrop-loading.component';
import { AlertComponent } from './features/alert/alert.component';
import { ToastComponent } from './features/toast/toast.component';
import { SplashScreenComponent } from './features/splash-screen/splash-screen.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    IonApp,
    IonRouterOutlet,
    BackdropLoadingComponent,
    AlertComponent,
    ToastComponent,
    SplashScreenComponent,
  ],
})
export class AppComponent {
  constructor(faLibrary: FaIconLibrary) {
    faLibrary.addIconPacks(fas, far, fab);
  }
}
